import {
  type GraphPath,
  IPF_NETWORK_VIEWER,
  IPF_NETWORK_VIEWER_LABEL,
  IPF_NO_VALUE_CLOUD,
  IPF_NO_VALUE_CLOUD_LABEL,
} from '@ipfabric/utils';

export const getPathNameLabel = (path: GraphPath): string => {
  if (path === IPF_NO_VALUE_CLOUD) {
    return IPF_NO_VALUE_CLOUD_LABEL;
  }
  if (path === IPF_NETWORK_VIEWER) {
    return IPF_NETWORK_VIEWER_LABEL;
  }
  return path;
};
